import { inBetweenDates } from "multi-date";
import MetaTags from "react-meta-tags";

interface PageProps {
	title: string;
	description: string;
	imageUrl: string;
	imageAlt?: string;
	keyword: string;
	listingList: any;
	amenityList: any;
	listingImg: any;
	dates: {
		checkin: "" | Date | null;
		checkout: "" | Date | null;
	};
	meta: any;
}

export default function ListingMetaTags({
	title,
	description,
	imageUrl,
	imageAlt,
	keyword,
	listingList = {},
	amenityList,
	listingImg,
	dates,
	meta,
}: PageProps) {
	const checkData = Object.values(amenityList);

	const maping = checkData.map((v) => {
		return {
			"@type": "LocationFeatureSpecification",
			name: v,
			value: true,
		};
	});

	// const dataJSON = JSON.stringify({
	// 	"@context": "https://schema.org",
	// 	"@type": "FAQPage",
	// 	mainEntity: [
	// 		{
	// 			"@type": "Question",
	// 			name: "What is the USP of this home?",
	// 			acceptedAnswer: {
	// 				"@type": "Answer",
	// 				text: meta?.seo_faq_usp,
	// 			},
	// 		},
	// 		{
	// 			"@type": "Question",
	// 			name: "What is this home Ideal For?",
	// 			acceptedAnswer: {
	// 				"@type": "Answer",
	// 				text: meta?.seo_faq_ideal_for,
	// 			},
	// 		},
	// 	],
	// });

	const ratingJSON = JSON.stringify({
		"@context": "http://schema.org",
		"@type": "BedAndBreakfast",
		name: listingList?.file_reference,
		description: listingList?.description,
		address: {
			"@type": "PostalAddress",
			addressCountry: "IN",
			addressLocality: listingList?.city,
			addressRegion: listingList?.state,
			postalCode: listingList?.pincode,
			streetAddress: "{} ",
		},
		telephone: "+91 8069160000",
		image: `	https://ik.imagekit.io/5tgxhsqev/saffronstays-media/tr:w-881,h-587,q-60/image/upload/${
			listingImg?.length > 0 && listingImg[0]
		}`,
		AggregateRating: {
			"@type": "AggregateRating",
			name: "rating",
			ratingValue: listingList?.rating?.overall / listingList?.rating?.reviews,
			ratingCount: listingList?.rating?.reviews,
		},
		brand: {
			"@type": "Brand",
			name: "SaffronStays",
		},
		priceRange: `₹${listingList?.per_night_charge} - ₹${listingList?.WEEKEND_NIGHT_CHARGE}`,
		geo: {
			"@type": "GeoCoordinates",
			latitude: meta?.latitude,
			longitude: meta?.longitude,
		},
		hasMap: {
			"@type": "Map",
			mapType: "http://schema.org/VenueMap",
			url: `http://maps.google.com/maps?q=${meta?.latitude},${meta?.longitude}`,
		},
		potentialAction: {
			"@type": "ReserveAction",
			target: {
				"@type": "EntryPoint",
				urlTemplate: window.location.href,
				inLanguage: "en-US",
				actionPlatform: [
					"http://schema.org/DesktopWebPlatform",
					"http://schema.org/IOSPlatform",
					"http://schema.org/AndroidPlatform",
				],
			},
			result: {
				"@type": "LodgingReservation",
				name: "Reserve Now",
			},
		},
		amenityFeature: maping,
		checkInTime: `${listingList?.in_time} ${listingList?.in_time_format}`,
		checkOutTime: `${listingList?.out_time} ${listingList?.out_time_format}`,
	});

	const breadCrumbsJSON = JSON.stringify({
		"@context": "https://schema.org",
		"@type": "BreadcrumbList",
		itemListElement: [
			{
				"@type": "ListItem",
				position: 1,
				item: {
					"@id": "https://www.saffronstays.com/",
					name: "Saffron Stays",
				},
			},
			{
				"@type": "ListItem",
				position: 2,
				item: {
					"@id": `https://www.saffronstays.com/search?location=${
						listingList?.file_refernce?.split("-")[0]
					}&checkin=&checkout=&guests=&rooms=&lat=${meta?.latitude}&lon=${
						meta?.longitude
					}`,
					name: listingList?.LOCATION,
				},
			},
			{
				"@type": "ListItem",
				position: 3,
				item: {
					"@id": window.location.href,
					name: listingList?.file_reference?.split("-")[0],
				},
			},
		],
	});

	return (
		<MetaTags>
			{/* <script type="text/javascript" defer>
				{`
					gtag("event", "view_item", {
						currency: "INR",
						value: "${listingList?.per_night_charge}",
						items: [{
							item_id: "${listingList?.id}",
							item_name: "${listingList?.file_reference}",
							item_brand: "${listingList?.state}",
							item_category: "${listingList?.city}",
							item_category2: "${listingList?.signature}",
							item_category3: "${listingList?.min_rooms}",
							item_category4: "${Object.keys(amenityList).includes("36")}",
							item_category5: "${Object.keys(amenityList).includes("19")}",
							item_variant: "${listingList?.TYPE_FLAG}",
							price: "${listingList?.per_night_charge}",
							quantity: "${inBetweenDates(dates.checkin, dates.checkout)}"
						}]
					});
				`}
			</script> */}
			<script defer>
				{`fbq('track', "view_item", {
    currency: "INR",
    value: "${listingList?.per_night_charge}",
    items: [{
        item_id: "${listingList?.id}",
        item_name: "${listingList?.file_reference}",
        item_brand: "${listingList?.state}",
        item_category: "${listingList?.city}",
        item_category2: "${listingList?.signature}",
        item_category3: "${listingList?.min_rooms}",
        item_category4: "${Object.keys(amenityList).includes("36")}",
        item_category5: "${Object.keys(amenityList).includes("19")}",
        item_variant: "${listingList?.TYPE_FLAG}",
        price: "${listingList?.per_night_charge}",
        quantity: "${inBetweenDates(dates.checkin, dates.checkout)}"
    }]
});`}
			</script>
		</MetaTags>
	);
}
